import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Icon, IconType, Container } from 'DVWebNodeUI'
import { ICollection } from '../../selectors/collections'
import { CarouselCollection } from '../carousel/carouselCollection'
import * as stPackshot from '../carousel/carouselCollectionItem.module.scss'
import * as st from './castAndCrew.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { SrcSize } from '../../utils/imageUtils'
import { ResponsiveImage } from '../images/responsiveImage'
import { StringId } from '../localizer/stringId'
import { TextLocalizer } from '../localizer/localizer'

const MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH = 112
const MEMBER_IMAGE_DEFAULT_WIDTH = 175

export interface ICastAndCrewProps {
  content?: WpsRuntime.atv.wps.CastAndCrewWidgetModelProps
}

const CastAndCrewRow = ({castMember}: {
  castMember: WpsRuntime.atv.wps.CastMemberModel,
}) => {
  const collectionsProps = {
    collectionType: castMember.titleCollections.collectionType,
    cardTitleIds: castMember.titleCollections.cards.map(card => card.titleID)
  } as ICollection

  const portraitFallback = <div className={st.noImage} >
    <Icon className={st.sash} use={IconType.LOGO_PRIMEVIDEO} />
  </div>

  const getCastImage = (imageUrl?: string) => {
    if (!imageUrl || imageUrl === '\\N') {
      return portraitFallback
    }

    const imgProps = {
      alt: '',
      src: imageUrl,
      baseValue: MEMBER_IMAGE_DEFAULT_WIDTH,
      srcSizes: [
        { 'max-phone-landscape': MEMBER_IMAGE_PHONE_LANDSCAPE_WIDTH },
      ] as SrcSize[]
    }

    return <ResponsiveImage {...imgProps}/>
  }

  const buildNameString = ( name: string, role?: string ) => role ? `${name} - ${role}` : name

  const { imageUrl, name, role } = castMember.cast

  return (
    <>
      <h3 className={`${st.name} ${stUtility.fullWidth}`}>
        {buildNameString(name, role)}
      </h3>
      <div className={`${st.imageRow} ${stPackshot.avSimsCarousel} cast-and-crew-member`}>
        <span className={`${st.castImage}`}>
          {getCastImage(imageUrl)}
        </span>
        <span className={st.carousel}>
          {collectionsProps.cardTitleIds.length > 0 &&
            <CarouselCollection {...collectionsProps} />}
        </span>
      </div>
    </>
  )
}

export const CastAndCrew = ({ content }: ICastAndCrewProps) => {
  const castMemberList = content && content.castAndCrews

  if (castMemberList && castMemberList.length > 0) {
    return (
      <Container className={`${stUtility.pageSection} cast-and-crew-section`}>
        <h2 className={st.title}><TextLocalizer stringID={StringId.DV_DP_CAST_CREW_HEADING} /></h2>
        {castMemberList.map((castMember, idx) =>
          <CastAndCrewRow castMember={castMember} key={idx}/>
        )}
      </Container>
    )
  } else {
    return null
  }
}
